import { MdDelete, MdEdit } from "react-icons/md";
import IconButton from "../atoms/IconButton";

const ActionsTables = ({ row, handleOpenDelete, handleOpenEdit }) => {
    return(
        <div className="flex flex-row gap-1">
            <IconButton icon={MdEdit} onClick={() => handleOpenEdit(row)} bgColor="bg-rs-azul" size="min-w-8 max-w-8" iconSize="text-2xl" />
            <IconButton icon={MdDelete} onClick={() => handleOpenDelete(row)} bgColor="bg-rs-rojo" size="min-w-8 max-w-8" iconSize="text-2xl" />
        </div>
    );
};

export default ActionsTables;